/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React from 'react';
import { animateScroll } from 'react-scroll';
import { IEnvironmentBridge } from './environment-bridge';

class BrowserEnvironmentBridge implements IEnvironmentBridge {
  finishFlow() {
    // document.dispatchEvent(new Event('flow.finished'));
    location.reload();
  }

  restartFlow() {
    // document.dispatchEvent(new Event('flow.aborted'));
    location.reload();
  }

  pushHistoryState(data) {
    history.pushState(data, null);
  }

  scrollViewportToTop() {
    animateScroll.scrollToTop();
  }
}

type EnvironmentBridgeContextType = {
  bridge: IEnvironmentBridge;
};

const EnvironmentBridgeContext =
  React.createContext<EnvironmentBridgeContextType>({
    bridge: new BrowserEnvironmentBridge(),
  });

export default EnvironmentBridgeContext;
